var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17V29.75",
    stroke: "#D20E50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8858 26.0525C30.2676 25.2992 31.3591 24.1073 31.9882 22.6647C32.6172 21.2222 32.748 19.6113 32.3598 18.0862C31.9716 16.5611 31.0866 15.2087 29.8445 14.2424C28.6023 13.2761 27.0737 12.7511 25.5 12.75H23.715C23.2862 11.0914 22.487 9.55166 21.3774 8.24643C20.2679 6.94119 18.8769 5.90448 17.309 5.21421C15.7411 4.52395 14.0371 4.19811 12.3252 4.26119C10.6132 4.32426 8.93785 4.77461 7.425 5.57838C5.91216 6.38215 4.60121 7.51842 3.59072 8.90176C2.58023 10.2851 1.89648 11.8795 1.59089 13.5652C1.2853 15.2508 1.36582 16.9838 1.82639 18.6338C2.28696 20.2838 3.1156 21.808 4.25001 23.0917",
    stroke: "#008F8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 22.6667L17 17L11.3333 22.6667",
    stroke: "#D20E50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.76c4b9d0.svg";
export { ForwardRef as ReactComponent };